export var KNOWLEDGE_HUB_FEATURE_NAME_KEY = 'KNOWLEDGE_HUB';